import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useTrainingMode } from "./TrainingModeContext";
import TrainingCoach from "./TrainingCoach";
import TrainingFeedbackToast from "./TrainingFeedbackToast";
import TrainingTour from "./TrainingTour";
import TrainingAutoNav from "./TrainingAutoNav";

import { useIsMobile } from "../hooks/useMediaQuery";

const DOCK = "340px";

function useIsNarrow(breakpoint = 900) {
  const [narrow, setNarrow] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth <= breakpoint : false,
  );
  useEffect(() => {
    const onResize = () => setNarrow(window.innerWidth <= breakpoint);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [breakpoint]);
  return narrow;
}

/** Одна панель справа + сдвиг контента. Без верхней полосы. */
export default function TrainingChrome() {
  const { active, coachCollapsed } = useTrainingMode();
  const narrow = useIsNarrow();
  const isMobile = useIsMobile(768);

  useEffect(() => {
    const root = document.documentElement;
    if (!active) {
      root.classList.remove("baysport-trn");
      root.style.removeProperty("--baysport-trn-right");
      root.style.removeProperty("--baysport-trn-top");
      return undefined;
    }
    root.classList.add("baysport-trn");
    root.style.setProperty("--baysport-trn-top", "0px");
    root.style.setProperty(
      "--baysport-trn-right",
      narrow || coachCollapsed || isMobile ? "0px" : DOCK,
    );
    return () => {
      root.classList.remove("baysport-trn");
      root.style.removeProperty("--baysport-trn-right");
      root.style.removeProperty("--baysport-trn-top");
    };
  }, [active, coachCollapsed, narrow, isMobile]);

  return createPortal(
    <>
      <TrainingAutoNav />
      <TrainingTour />
      <TrainingCoach />
      <TrainingFeedbackToast />
    </>,
    document.body,
  );
}
